import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PT from 'prop-types';
import CrossOutline from '@scaleflex/icons/cross-outline';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import { Size } from './types';
import Styled from './cross-button.styles';
var getIconSize = function getIconSize(sizeName) {
  switch (sizeName) {
    case Size.Lg:
      return 16;
    case Size.Xs:
      return 10;
    case Size.Sm:
    default:
      return 12;
  }
};
var CrossButton = intrinsicComponent(function (_ref, ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(Styled.CrossButton, _extends({}, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement(CrossOutline, {
    size: getIconSize(rest.size)
  }));
});
CrossButton.defaultProps = {
  size: Size.Lg
};
CrossButton.propTypes = {
  size: PT.oneOf(objectValues(Size))
};
export default CrossButton;